(function () {
  'use strict';

  if (window.BiossHomepageOnlyModernV107Started) return;
  window.BiossHomepageOnlyModernV107Started = true;

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function initHomeSlider() {
    var root = qs('[data-bioss-home-slider-v107]');
    if (!root || root.getAttribute('data-bioss-slider-ready') === 'true') return;

    var slides = qsa('[data-bioss-slide-v107]', root);
    var countEl = qs('[data-bioss-home-count-v107]');
    var prev = qs('[data-bioss-home-prev-v107]');
    var next = qs('[data-bioss-home-next-v107]');
    var hero = root.closest('.bioss-home-hero-v107');
    var dots = qsa('[data-bioss-home-dot-v361]', hero);
    var pause = qs('[data-bioss-home-pause-v361]', hero);
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var paused = reducedMotion.matches;
    var index = 0;
    var timer = null;

    if (!slides.length) return;

    function show(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        slide.inert = i !== index;
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      hero.style.setProperty('--bioss-slide-height', root.offsetHeight + 'px');

      if (countEl) {
        countEl.textContent = (index + 1) + ' / ' + slides.length;
      }
    }

    function schedule() {
      window.clearInterval(timer);
      if (paused) return;
      timer = window.setInterval(function () {
        if (document.hidden || hero.matches(':hover') || hero.contains(document.activeElement)) return;
        show(index + 1);
      }, 6000);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        show(index - 1);
        schedule();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        show(index + 1);
        schedule();
      });
    }

    document.addEventListener('visibilitychange', schedule);
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); schedule(); });
    });
    function updatePause() {
      if (!pause) return;
      pause.innerHTML = paused
        ? '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 2L14 8L4 14Z"/></svg>'
        : '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 2H6V14H3ZM10 2H13V14H10Z"/></svg>';
      pause.setAttribute('aria-label', pause.getAttribute(paused ? 'data-play-label' : 'data-pause-label'));
    }
    if (pause) pause.addEventListener('click', function () {
      paused = !paused;
      updatePause();
      schedule();
    });
    reducedMotion.addEventListener('change', function (event) {
      paused = event.matches;
      updatePause();
      schedule();
    });
    if ('ResizeObserver' in window) new ResizeObserver(function () {
      hero.style.setProperty('--bioss-slide-height', root.offsetHeight + 'px');
    }).observe(root);
    updatePause();

    root.setAttribute('data-bioss-slider-ready', 'true');
    show(0);
    schedule();
  }

  function boot() {
    if (!document.body || !document.body.classList.contains('template-index')) return;
    initHomeSlider();
    window.setTimeout(initHomeSlider, 500);
    window.setTimeout(initHomeSlider, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.addEventListener('load', boot);
})();
